import { Button } from "@knowtex-ai/components";
import { Sparks } from "iconoir-react";
import { SMART_CHART_SMART_ASSIST_PROMPTS } from "../../noteList/SmartAssistPromptTools";
import type { SmartAssistQuickAction } from "../core/types";

interface SmartAssistQuickPromptsProps {
  disabled: boolean;
  onSelect: (action: SmartAssistQuickAction) => void;
  onCreatePrompt?: () => void;
  actions?: SmartAssistQuickAction[];
  showCreatePrompt?: boolean;
}

const BUBBLE_CLASS =
  "min-w-0 max-w-full whitespace-normal break-words rounded-full border border-violet-200 bg-violet-50 px-3 py-1.5 text-center text-xs font-semibold text-accent1 transition hover:border-violet-300 hover:bg-violet-100 disabled:cursor-not-allowed disabled:opacity-50";

export default function SmartAssistQuickPrompts({
  disabled,
  onSelect,
  onCreatePrompt,
  actions = SMART_CHART_SMART_ASSIST_PROMPTS,
  showCreatePrompt = true,
}: SmartAssistQuickPromptsProps) {
  return (
    <div
      className="flex min-w-0 max-w-full flex-wrap gap-2 overflow-hidden px-1 pb-2"
      aria-label="Suggested Smart Assist prompts"
    >
      {actions.map((action) => (
        <Button
          key={action.id || action.label}
          type="button"
          variant="secondary"
          size="small"
          disabled={disabled}
          onClick={() => onSelect(action)}
          className={BUBBLE_CLASS}
        >
          {action.label}
        </Button>
      ))}
      {showCreatePrompt && onCreatePrompt && (
        <Button
          type="button"
          variant="secondary"
          size="small"
          disabled={disabled}
          onClick={onCreatePrompt}
          icon={Sparks}
          className={BUBBLE_CLASS}
        >
          Create a prompt
        </Button>
      )}
    </div>
  );
}
